import { gql, useMutation, MutationHookOptions } from '@apollo/client';

export const query = gql`
  mutation EditHiveUser(
    $userId: String!
    $firstName: String
    $lastName: String
    $userName: String
    $password: String
    $allowedHiveGames: [String!]
    $hiveId: String
  ) {
    editHiveUser(
      userId: $userId
      firstName: $firstName
      lastName: $lastName
      userName: $userName
      password: $password
      allowedHiveGames: $allowedHiveGames
      hiveId: $hiveId
    ) {
      id
      firstName
      lastName
      userName
      password
      allowedHiveGames
    }
  }
`;

export interface RequestType {
  userId: string;
  firstName?: string;
  lastName?: string;
  userName?: string;
  password?: string;
  allowedHiveGames?: string[] | null;
  hiveId?: string;
}

export interface MutationType {
  editHiveUser: {
    id: string;
    firstName?: string;
    lastName?: string;
    userName?: string;
    password?: string;
    allowedHiveGames?: string[] | null;
    hiveId?: string;
  };
}

export function useEditUserFromHiveMutation(
  options?: MutationHookOptions<MutationType, RequestType>,
) {
  return useMutation<MutationType, RequestType>(query, options);
}
